// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React examples
import SimpleInfoCard from "custom/Cards/InfoCards/SimpleInfoCard";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function Information() {
  return (
    <MKBox component="section" py={6} mt={6}>
      <Container>
        <Grid container spacing={3} item xs={12} lg={8} mx="auto">
          <MKTypography variant="h3" mb={7}>
            ¿Qué es la Prueba de Penetración Interna?
          </MKTypography>
          <MKTypography variant="body2" align="justify">
            La prueba de penetración interna, también conocida como prueba de red interna o evaluación interna, es un proceso sistemático y controlado que simula una amenaza interna o una red interna comprometida. El objetivo principal es identificar vulnerabilidades y debilidades dentro de la red interna, sistemas y aplicaciones de una organización que podrían ser explotadas por actores malintencionados o internos.
          </MKTypography>
          <MKTypography variant="h3" mb={7} mt={7}>
            Aspectos Clave de la Prueba de Penetración Interna
          </MKTypography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="my_location"
                title="Definición del Alcance"
                description="El alcance de la prueba de penetración interna se define cuidadosamente para evaluar activos específicos, sistemas o segmentos de red dentro de una organización. Esto asegura que las pruebas estén alineadas con los objetivos de seguridad de la organización."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="view_in_ar"
                title="Ataques Simulados"
                description="Los evaluadores de penetración interna utilizan técnicas similares a las empleadas por atacantes reales, buscando explotar vulnerabilidades para obtener acceso no autorizado, escalar privilegios y moverse lateralmente dentro de la red."
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ mt: { xs: 0, md: 1 } }}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="pentagon"
                title="Informes Exhaustivos"
                description="Después de las pruebas, las organizaciones reciben informes detallados que describen las vulnerabilidades identificadas, el impacto de posibles explotaciones y recomendaciones para mitigación y remediación."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="description"
                title="Guía de Remediación"
                description="Los evaluadores de penetración interna a menudo proporcionan orientación y apoyo a las organizaciones para abordar y remediar las vulnerabilidades identificadas, ayudando a mejorar la postura general de seguridad."
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ mt: { xs: 0, md: 1 } }}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="analytics"
                title="Evaluación de Riesgos"
                description="Los resultados de la prueba de penetración interna se utilizan para evaluar los riesgos y vulnerabilidades de seguridad de la organización. Cada hallazgo se clasifica por gravedad, ayudando a las organizaciones a priorizar los esfuerzos de remediación."
              />
            </Grid>
          </Grid>
          <MKTypography variant="h3" mb={7} mt={7}>
            ¿Por qué Importa la Prueba de Penetración Interna?
          </MKTypography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="input_circle"
                title="Mitigación de Amenazas Internas"
                description="Ayuda a las organizaciones a identificar y mitigar debilidades de seguridad que podrían ser explotadas por insiders malintencionados, ya sea de manera intencional o no intencional."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="trending_down"
                title="Reducción de Riesgos"
                description="Al identificar y abordar proactivamente las vulnerabilidades, las organizaciones pueden reducir el riesgo de brechas de datos, acceso no autorizado y interrupciones operativas."
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ mt: { xs: 0, md: 1 } }}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="gavel"
                title="Cumplimiento y Garantía"
                description="Muchas industrias y organismos reguladores requieren evaluaciones de seguridad regulares, incluida la prueba de penetración interna, para demostrar el cumplimiento y la diligencia debida en la protección de datos sensibles."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="restart_alt"
                title="Mejora Continua"
                description="La prueba de penetración interna proporciona información valiosa sobre la postura de seguridad de una organización, permitiendo mejoras continuas en las medidas y prácticas de seguridad."
              />
            </Grid>
          </Grid>
          <MKTypography variant="h3" mb={7} mt={7}>
            El Rol de la Prueba de Penetración Interna en la Ciberseguridad
          </MKTypography>
          <MKTypography variant="body2" align="justify">
            La prueba de penetración interna es un componente crucial de una estrategia integral de ciberseguridad. Ayuda a las organizaciones a identificar y abordar vulnerabilidades de seguridad desde dentro, asegurando que sus redes y sistemas internos sean resilientes tanto a amenazas internas como externas. Al invertir en servicios de prueba de penetración interna, las organizaciones pueden fortalecer su postura de seguridad y mantener la confianza en un mundo digital cada vez más interconectado.
          </MKTypography>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;